(function () {
  'use strict';

  const optionWords = new Map([
    ['gebinde', 'Gebinde'],
    ['inhalt', 'Größen'],
    ['inhalt:', 'Größen'],
    ['groesse', 'Größen'],
    ['größe', 'Größen'],
    ['size', 'Größen'],
    ['packungsgroesse', 'Größen'],
    ['packungsgröße', 'Größen'],
    ['packgrößen', 'Größen'],
    ['farbe', 'Farben'],
    ['farben', 'Farben'],
    ['farbvariante', 'Farben'],
    ['duft', 'Düfte'],
    ['länge', 'Längen'],
    ['breite', 'Breiten'],
    ['material', 'Materialien'],
    ['gewicht', 'Gewichte'],
    ['verpackung', 'Verpackungen'],
    ['abmessungen', 'Abmessungen'],
    ['feinheitsgrad', 'Feinheitsgrade'],
    ['stärke', 'Stärken'],
  ]);

  class RccProductVariantCount extends HTMLElement {
    static get graphqlRequirements() {
      return {
        metafields: [{ namespace: 'custom', key: 'custom_inhalt' }],
      };
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      this.render();
    }

    render() {
      const product = this._product;
      const variants = product?.variantsAll || (
        product?.graphql?.variants?.pageInfo?.hasNextPage === false
          ? product.graphql.variants.nodes : []
      ) || [];
      let text = '';
      let display = '';

      if (variants.length > 1) {
        const optionNames = new Set(
          variants.flatMap((variant) => variant?.selectedOptions || [])
            .map((option) => option?.name?.trim())
            .filter(Boolean),
        );
        const optionName = optionNames.size === 1 ? [...optionNames][0].toLocaleLowerCase('de-DE') : '';
        text = `${variants.length} ${optionWords.get(optionName) || 'Varianten'}`;
        display = 'variants';
      } else if (variants.length === 1) {
        text = product?.metafields?.[0]?.value?.trim() || '';
        display = 'content';
      }

      this.textContent = text;
      this.hidden = !text;
      if (text) this.setAttribute('data-display', display);
      else this.removeAttribute('data-display');
    }
  }

  if (!customElements.get('rcc-product-variant-count')) {
    customElements.define('rcc-product-variant-count', RccProductVariantCount);
  }
})();
